import React from 'react';
import { Card, Typography, Divider, Space, Button } from 'antd';
import { ArrowLeftOutlined, FileTextOutlined, CheckCircleOutlined, WarningOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Paragraph, Text } = Typography;

const TermsPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <style>
        {`
          .terms-page-container::-webkit-scrollbar {
            width: 12px;
          }
          
          .terms-page-container::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 6px;
          }
          
          .terms-page-container::-webkit-scrollbar-thumb {
            background: #c1c1c1;
            border-radius: 6px;
          }
          
          .terms-page-container::-webkit-scrollbar-thumb:hover {
            background: #a8a8a8;
          }
        `}
      </style>
      <div 
        className="terms-page-container"
        style={{ 
          padding: '24px',
          background: 'linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%)',
          minHeight: '100vh',
          overflowY: 'auto',
          height: '100vh'
        }}
      >
        <div style={{ 
          maxWidth: '800px', 
          margin: '0 auto',
          paddingBottom: '24px'
        }}>
    
          <Card 
            style={{ 
              borderRadius: '12px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)'
            }}
          >
            <div style={{ textAlign: 'center', marginBottom: 32 }}>
              <FileTextOutlined style={{ fontSize: '48px', color: '#1890ff', marginBottom: 16 }} />
              <Title level={1} style={{ margin: 0, color: '#1f2937' }}>
                Terms of Service & Lead Purchase Agreement
              </Title>
              <Text type="secondary" style={{ fontSize: '16px' }}>
                LeadSlope, Inc. DBA as FifthStreet LLC and topagentpromoter
              </Text>
            </div>

            <Divider />

            <Space direction="vertical" size={24} style={{ width: '100%' }}>
              
              {/* Credit Card Authorization Section */}
              <div>
                <Title level={3} style={{ color: '#1f2937', marginBottom: 16 }}>
                  <CheckCircleOutlined style={{ marginRight: 8, color: '#52c41a' }} />
                  Credit Card Authorization
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  I am the owner or holder of the Credit Card identified and used for the purchase of leads
                  and am authorized to use such Credit Card for the purchases and transactions authorized 
                  by this Agreement. I hereby authorize LeadSlope to charge this Credit Card in the amount 
                  corresponding to the number of leads being purchased for this transaction.
                </Paragraph>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  I understand and agree that by submitting this Credit Card Authorization, I am authorizing 
                  LeadSlope to immediately charge my credit card in the amount corresponding to the 
                  number of leads being purchased. I am agreeing to be bound by the policies set forth in the 
                  Lead Purchase Agreement and, in particular, Sections of that agreement which sets forth 
                  LeadSlope refund and chargeback policy restated below.
                </Paragraph>
              </div>

              {/* Refund Policy Section */}
              <div>
                <Title level={3} style={{ color: '#1f2937', marginBottom: 16 }}>
                  <CheckCircleOutlined style={{ marginRight: 8, color: '#52c41a' }} />
                  Refund Policy
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  <Text strong>REFUNDS AND OR CREDITS ARE OFFERED ONLY IN TWO (2) CIRCUMSTANCES:</Text>
                </Paragraph>
                <div style={{ marginLeft: 24, marginTop: 16 }}>
                  <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                    <Text strong>1.</Text> A credit to your account will be given if you were over billed due to a technical error.
                  </Paragraph>
                  <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                    <Text strong>2.</Text> A lead purchased is delivered with a disconnected number.
                  </Paragraph>
                </div>
              </div>

              {/* Chargeback Policy Section */}
              <div>
                <Title level={3} style={{ color: '#1f2937', marginBottom: 16 }}>
                  <WarningOutlined style={{ marginRight: 8, color: '#fa8c16' }} />
                  Chargeback Policy
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  <Text strong>CHARGEBACK POLICY:</Text> If you use a Credit Card to purchase leads, 
                  <Text strong style={{ color: '#cf1322' }}> YOU AGREE TO NOT CHARGE BACK YOUR CARD for ANY reason.</Text>
                </Paragraph>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  In the event you breach this term and you charge back your credit card for all or partial amounts within your 
                  account, you will be charged an administrative service fee of five hundred ($500) dollars, 
                  which you agree to pay in addition to the amount of the Lead purchase fee due for Leads 
                  you have received to the date of the chargeback.
                </Paragraph>
              </div>

              {/* Agreement Section */}
              <div>
                <Title level={3} style={{ color: '#1f2937', marginBottom: 16 }}>
                  <CheckCircleOutlined style={{ marginRight: 8, color: '#52c41a' }} />
                  Agreement
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  By checking the box, you agree to all terms of service and chargeback policy. In addition, 
                  you have read, understood, and hereby agree to the Lead Purchase Agreement including all 
                  return and chargeback provisions contained therein.
                </Paragraph>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  I hereby authorized LeadSlope, Inc. DBA as FifthStreet LLC and topagentpromoter, to charge my Credit Card and purchase 
                  leads from FifthStreetLLC / topagentpromoter, Inc. I understand and agree with the Terms 
                  specified above.
                </Paragraph>
              </div>

              {/* Contact Information */}
              <Divider />
              <div style={{ textAlign: 'center', padding: '24px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                <Title level={4} style={{ color: '#1f2937', marginBottom: 8 }}>
                  Questions or Concerns?
                </Title>
                <Text type="secondary" style={{ fontSize: '14px' }}>
                  If you have any questions about these terms, please contact our support team.
                </Text>
              </div>

            </Space>
          </Card>
        </div>
      </div>
    </>
  );
};

export default TermsPage; 